// extracted by mini-css-extract-plugin
export default {"root":"SMGQFEg2AwYrihLsxxNm","code_block":"YLRO9qm4LZfb4FqPgYwZ","copy_button":"buF5Hb4X_DaXOSHEtbqw","action_button":"JFkmgYvDkfZyjtIyFYrl","header":"yFMS9e3Eq9lFKnZPKfjf"};